import { useQuery } from "@tanstack/react-query";
import { makeApiRequest } from "../../utils";
import { SUPPORT_PLAID_TRANSACTIONS_QUERY_KEY } from "../../../constants/queryKeys";

export const usePlaidTransactions = (
  plaidItemId, plaidAccountId, enabled
) => {
  return useQuery({
    queryKey: [
      SUPPORT_PLAID_TRANSACTIONS_QUERY_KEY,
      plaidItemId,
      plaidAccountId
    ],
    queryFn: async () => {
      return makeApiRequest({
        endpoint: `/api/support/plaid-transactions/${plaidItemId}/${plaidAccountId}`,
        method: "GET"
      });
    },
    enabled: !!plaidItemId && !!plaidAccountId && enabled,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    retry: false
  });
};
